import angular from 'angular'
import platform from 'platform'

import { BaseView } from '../../../shared/utils/baseComponent'
import template from './login.component.pug'
import css from './login.component.scss'

class LoginController extends BaseView {
  constructor($element, SessionService, UserService, $cookies, $state, $timeout, $mdToast, $q, $location) {
    'ngInject'
    super($element)
    Object.assign(
      this,
      { $element, SessionService, UserService, $cookies, $state, $timeout, $mdToast, $q, $location },
      {
        customers: [],
        fields: ['email', 'password'],
        showLegacyWarning: true,
      },
    )
  }

  login() {
    return this.SessionService.authenticateByCredentials(this.user)
      .then((user) => {
        if (this.$location.search() && this.$location.search().redirect) {
          return this.$location.url(this.$location.search().redirect)
        }
        if (user.customers.length === 1) {
          return this.$state.go('customers.customer.tasksites', { customerId: user.customers[0].customer.no })
        }
        this.customers = user.customers
        this.activeTab = 1
      })
      .catch((err) => {
        if (err.status === 405) {
          this.$mdToast.show(
            this.$mdToast
              .simple()
              .textContent(
                'System ist aktuell nicht erreichbar. Bitte versuchen Sie es zu einem späteren Zeitpunkt nochmal.',
              )
              .action('OK')
              .position('bottom')
              .hideDelay(10000),
          )
        }
        if (err.status !== 401) return console.error(err)
        this.fields.forEach((field) => this.loginFrm[field].$setValidity('credentials', false))
        this.compareCredentialsTo = angular.copy(this.user)
      })
  }

  compareCredentials() {
    this.fields.forEach((field) =>
      this.loginFrm[field].$setValidity('credentials', !angular.equals(this.compareCredentialsTo, this.user)),
    )
  }

  isLegacyBrowser() {
    let browserInList = false
    const browser = platform.name
    const version = parseInt(platform.version.split('.')[0])
    const minVersions = {
      IE: 11,
      'Microsoft Edge': 14,
      Firefox: 56,
      Safari: 10,
      Chrome: 49,
      'Chrome Mobile': 62,
      'Firefox Mobile': 57,
      'Android Browser': 4,
    }
    for (let b in minVersions) {
      if (browser.toLowerCase() === b.toLowerCase()) {
        browserInList = true
        if (version < minVersions[b]) {
          return true
        }
      }
    }
    return !browserInList
  }

  browser() {
    return platform.name + ' Version ' + platform.version
  }

  closeLegacyPopup() {
    this.showLegacyWarning = false
  }
}

export const loginComponent = {
  controller: LoginController,
  bindings: {
    invitation: '<',
  },
  template: template({ css }),
}



// WEBPACK FOOTER //
// ./app/account/containers/login/login.component.js